// extracted by mini-css-extract-plugin
module.exports = {"big-logo-wrap":"_3lmaE","nav-section":"_30Ge3","trademark":"E8brN","services":"XRY48"};